import { viewItemEvent } from './utils/viewItem';

export function viewItemProductPageEvent() {
  const button = document.querySelector<HTMLButtonElement>(
    '[data-button-add-to-cart]',
  );
  const quantitySelector = document.querySelector<HTMLInputElement>(
    '[data-quantity-value]',
  );

  if (!button) return;

  const id = button.dataset.ga4ProductId!;
  const itemName = button.dataset.ga4ProductName!;
  const price = Number(button.dataset.ga4ProductPrice);
  const quantity = quantitySelector ? Number(quantitySelector.value) : 1;

  const item: Item = {
    item_id: id,
    item_name: itemName,
    price: price,
    quantity: quantity,
  };

  viewItemEvent(item);
}
